<ion-card class="etlap-kartya" *ngIf="lathato">
  <ion-card-header>
    <ion-card-title>
      <ion-icon name="restaurant-outline" class="etlap-cim-ikon"></ion-icon>{{ cim }}
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="etlap-lapozo">
      <ion-button size="small" fill="clear" (click)="lapoz(-1)" title="Előző hét" aria-label="Előző hét">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <span class="etlap-het">{{ hetCim }}</span>
      <ion-button size="small" fill="clear" (click)="lapoz(1)" title="Következő hét" aria-label="Következő hét">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" fill="outline" *ngIf="eltolas !== 0" (click)="lapoz(0)">Ez a hét</ion-button>
      <ion-button size="small" fill="outline" *ngIf="eltolas === 0" (click)="lapoz(1)">Jövő hét</ion-button>
      <ion-spinner name="dots" *ngIf="fut"></ion-spinner>
    </div>

    <div class="etlap-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="etlap-ures" *ngIf="!fut && !hiba && !vanAdat">Erre a hétre még nincs feltöltött étlap.</div>

    <div class="etlap-hetracs" *ngIf="vanAdat">
      <div class="etlap-nap" *ngFor="let n of napok; trackBy: trackNap" [class.ma]="n.ma">
        <div class="etlap-nap-cim">{{ n.cim }}<span class="etlap-ma" *ngIf="n.ma">ma</span></div>
        <div class="etlap-nincs" *ngIf="!n.sorok.length">–</div>
        <div class="etlap-tetel" *ngFor="let s of n.sorok">
          <span class="etlap-jel" [title]="s.menu_cim ? 'Rendelhető menü: ' + s.menu_cim : ''">
            {{ tobbBeszallito && s.hely_nev ? s.hely_nev + ' – ' : '' }}{{ s.menu_nev }}
          </span>
          <span class="etlap-etel">{{ s.leiras }}</span>
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>
